import React from "react";
import { compose } from "recompose";
import {
  Drawer,
  Form,
  Collapse,
  Row,
  Col,
  Button,
  Select,
  Spin,
  Icon,
  notification,
} from "antd";
import { withApollo, graphql } from "react-apollo";
import moment from "moment";
import { getUserByID } from "../../../../graphQl/queries/users";
import {
  TitleDrawer,
  CustomCollapse,
  ContainerForm,
  BlockSeparator,
  ContainerButtons,
  CustomDatePicker,
  AGENCY_PORTAL_CLASS,
} from "./style";
import Container from "../../../../components/Container";
import {
  InputComponentWithBorder,
  SelectWithBorderComponent,
} from "./AgencyFormFields";
import { CustomRow } from "../../../../components/Grid";
import { withGlobal } from "../../../../component-global";
import {
  getDataFromPreAffiliate,
  typeVehicleAffiliates,
  categoryLicenceAffiliates,
  documentTypeAffiliates,
} from "../../../../graphQl/queries/affiliate";
import {
  updateDataAffiliateDrawer,
} from "../../../../graphQl/mutations/affiliate";
import ImageUpload from "../../../../components/UploadImg";
import UploadModalFile from "../../../../components/UploadModalFile";

const { Panel } = Collapse;
const { Option } = Select;
const defaultImgProfile =
  "https://firebasestorage.googleapis.com/v0/b/chazki-link.appspot.com/o/nintendo%2Fuser.svg?alt=media&token=93cce15e-8f5b-4303-b9c7-ce570b59bf2b";
// bicicleta y bicicleta electrica
const BICYCLE_VEHICLE_IDS = [234, 555];
// campos que no aplican cuando el tipo de vehiculo es bicicleta
const BICYCLE_HIDDEN_FIELDS = [
  "vehiclePlate",
  "driverLicenceNumber",
  "driverLicenceCategoryID",
  "driverLicenceExpirationDate",
  "driverLicencePhoto",
  "soatPhoto",
];
class DrawerComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingActions: true,
      loadingBtnSubmit: false,

      prefixCountry: null,
      countrySelected: null,
      citySelected: null,
      citiesCountry: [],
      dataUser: null,
      fieldsUpdated: [],

      // variables para la subida de archivos
      folderName: "nintendo",
      target: "profilesUsers",
      visibleModalDocumentBrevetePhoto: false,
      visibleModalDocumentSoatPhoto: false,
      urlBrevetePhoto: null,
      urlSoatPhoto: null,

      selectedVehicle: null,
    };
  }

  initializeCountryCity = async () => {
    const { dataCountries, authUser } = this.props;
    if (!dataCountries || dataCountries.length === 0) {
      return;
    }

    let countryID = null;
    let cityID = null;

    if (authUser?.profile?.sub) {
      try {
        const {
          data: { UserByID },
        } = await this.props.client.query({
          fetchPolicy: "network-only",
          query: getUserByID,
          variables: { id: authUser.profile.sub },
        });
        countryID = UserByID?.countryID;
        cityID = UserByID?.cityID;
      } catch (err) {
        // fallback below
      }
    }

    if (countryID != null) {
      this.onChangeCountries(countryID);
      if (cityID != null) {
        this.setState({ citySelected: `${cityID}` });
      }
    } else {
      this.onChangeCountries(dataCountries[0].id);
    }
  };

  componentDidMount = async () => {
    const { userID } = this.props;

    let dataAffiliate = null;

    try {
      const [, affiliateResult] = await Promise.all([
        this.initializeCountryCity(),
        this.props.client
          .query({
            fetchPolicy: "network-only",
            query: getDataFromPreAffiliate,
            variables: {
              affiliateID: userID,
            },
          })
          .catch(err => {
            console.error("Error loading affiliate data:", err);
            return null;
          }),
      ]);

      dataAffiliate = affiliateResult?.data?.getDataFromPreAffiliate ?? null;
    } catch (err) {
      console.error("Error loading drawer data:", err);
    }

    this.setState({
      loadingActions: false,
      dataUser: dataAffiliate,
      selectedVehicle: dataAffiliate?.CurrentVehicle?.categoryVehicleID
        ? `${dataAffiliate.CurrentVehicle.categoryVehicleID}`
        : null,
      urlImgProfile:
        dataAffiliate &&
        dataAffiliate.User &&
        dataAffiliate.User.picture !== null &&
        dataAffiliate.User.picture.length > 10
          ? dataAffiliate.User.picture
          : defaultImgProfile,
      urlBrevetePhoto:
        dataAffiliate &&
        dataAffiliate.AffiliateDriveInfo &&
        dataAffiliate.AffiliateDriveInfo.driverLicencePhoto
          ? dataAffiliate.AffiliateDriveInfo.driverLicencePhoto
          : null,
      urlSoatPhoto:
        dataAffiliate &&
        dataAffiliate.AffiliateDriveInfo &&
        dataAffiliate.AffiliateDriveInfo.soatPhoto
          ? dataAffiliate.AffiliateDriveInfo.soatPhoto
          : null,
    });
  };

  changeInputValue = (keyValue, e, table, dataType) => {
    const { fieldsUpdated } = this.state;
    const positionOfSearchedObject = fieldsUpdated.findIndex(
      elem => elem.field === keyValue
    );
    if (positionOfSearchedObject === -1) {
      fieldsUpdated.push({
        field: keyValue,
        value: e,
        table,
        dataType,
      });
    } else {
      fieldsUpdated[positionOfSearchedObject].value = e;
    }
    this.setState({
      fieldsUpdated,
    });
    if (keyValue === "categoryVehicleID") this.onChangeVehicle(e);
  };

  isBicycle = categoryVehicleID =>
    BICYCLE_VEHICLE_IDS.includes(parseInt(categoryVehicleID, 10));

  // al seleccionar bicicleta se descartan los cambios no guardados de los campos
  // que se ocultan, sin tocar los datos ya registrados del vehiculo anterior
  onChangeVehicle = categoryVehicleID => {
    if (!this.isBicycle(categoryVehicleID)) {
      this.setState({ selectedVehicle: categoryVehicleID });
      return;
    }
    const driveInfo = this.state.dataUser?.AffiliateDriveInfo;
    this.setState(prevState => ({
      selectedVehicle: categoryVehicleID,
      fieldsUpdated: prevState.fieldsUpdated.filter(
        elem => !BICYCLE_HIDDEN_FIELDS.includes(elem.field)
      ),
      urlBrevetePhoto: driveInfo?.driverLicencePhoto || null,
      urlSoatPhoto: driveInfo?.soatPhoto || null,
    }));
  };

  onChangeCountries = countryID => {
    const { dataCountries = [] } = this.props;
    const findElem = dataCountries.find(
      elem => String(elem.id) === String(countryID)
    );
    const { resetFields } = this.props.form;

    resetFields(["cityID"]);
    this.setState({
      prefixCountry: findElem ? findElem.prefixPhone : "",
      countrySelected: findElem ? findElem.id : "",
      citiesCountry: findElem ? findElem.Cities : [],
      citySelected:
        findElem && findElem.Cities.length > 0 ? findElem.Cities[0].id : "",
    });
  };

  submitDataForm = () => {
    const { fieldsUpdated } = this.state;
    const { userID } = this.props;

    if (!userID) {
      notification.error({
        message: "No se encontró el afiliado a editar.",
      });
      return;
    }

    this.props.form.validateFieldsAndScroll(err => {
      if (!err) {
        const dateToday = Date();
        const datelicenseExpirationDate = fieldsUpdated.find(
          fieldsValues => fieldsValues.field === "driverLicenceExpirationDate"
        );
        if (
          datelicenseExpirationDate &&
          moment(dateToday).format("YYYY-MM-DD") >
            datelicenseExpirationDate.value
        ) {
          notification.error({
            message: "No puede registrarse, la licencia está vencida",
          });
          this.setState({ loadingBtnSubmit: false });
          return;
        }

        if (!this.props.permissionsView?.edit) {
          notification.error({
            message: "No tiene permisos para editar afiliados.",
          });
          return;
        }

        const { loadTable } = this.props;
        this.setState({ loadingBtnSubmit: true });
        if (fieldsUpdated.length > 0) {
          const variables = {
            affiliateID: userID,
            data: fieldsUpdated.map(obj => {
              return { field: obj.field, value: obj.value };
            }),
          };
          this.props.client
            .mutate({
              mutation: updateDataAffiliateDrawer,
              update: (
                cache,
                { data: { updateAffiliateData: response } }
              ) => {
                this.setState({ loadingBtnSubmit: false });
                if (response.statusCode === 200) {
                  notification.success({ message: response.message });
                  this.closeDrawer();
                  loadTable();
                } else notification.error({ message: response.message });
              },
              variables,
            })
            .catch(() => {
              this.setState({ loadingBtnSubmit: false });
              notification.error({
                message: "Hubo un error al actualizar los datos.",
              });
            });
        } else {
          notification.success({
            message: "Se actualizaron los datos correctamente.",
          });
          this.closeDrawer();
          loadTable();
        }
      } else {
        notification.error({
          message: "Ingrese todos los campos obligatorios.",
        });
      }
    });
  };

  closeDrawer = () => {
    const { loadingBtnSubmit } = this.state;
    if (!loadingBtnSubmit) this.props.onClose();
  };

  // /////////////////////////////
  // funciones para actualizar los nombres de los archivos
  onUpdateFieldsImg = imgDefault => {
    this.changeInputValue("picture", imgDefault, "Users", "string");
    this.setState({ urlImgProfile: imgDefault });
  };

  onDeleteFieldsImg = () => {
    this.changeInputValue("picture", "", "Users", "string");
    this.setState({ urlImgProfile: defaultImgProfile });
  };

  // /////////////////////////////
  // funciones para subir imágenes por el modal
  showModalDocumentBrevetePhoto = () => {
    this.setState({
      visibleModalDocumentBrevetePhoto: true,
    });
  };

  showModalDocumentSoatPhoto = () => {
    this.setState({
      visibleModalDocumentSoatPhoto: true,
    });
  };

  hideModalDocumentBrevetePhoto = () => {
    this.setState({
      visibleModalDocumentBrevetePhoto: false,
    });
  };

  hideModalDocumentSoatPhoto = () => {
    this.setState({
      visibleModalDocumentSoatPhoto: false,
    });
  };

  // funciones para actualizar los estados de los  modales
  onUpdateFieldDocumentBrevetePhoto = url => {
    this.changeInputValue("driverLicencePhoto", url, "DriverInfo", "string");
    this.setState({ urlBrevetePhoto: url });
  };

  onUpdateFieldDocumentSoatPhoto = url => {
    this.changeInputValue("soatPhoto", url, "DriverInfo", "string");
    this.setState({ urlSoatPhoto: url });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      visible,
      dataCountries,
      typeVehicle = {},
      categoryLicence = {},
      documentType = {},
    } = this.props;
    const {
      searchGeneralTypesBy: typeVehicleOptions,
      loading: typeVehicleLoading = false,
    } = typeVehicle;
    const {
      searchGeneralTypesBy: categoryLicenceOptions,
      loading: categoryLicenceLoading = false,
    } = categoryLicence;
    const {
      searchGeneralTypesBy: documentTypeOptions,
      loading: documentTypeLoading = false,
    } = documentType;
    const {
      loadingActions,
      loadingBtnSubmit,
      citySelected,
      citiesCountry,
      countrySelected,
      dataUser,
      urlImgProfile,
      selectedVehicle,
    } = this.state;
    const isBicycle = this.isBicycle(selectedVehicle);

    // upload images
    const {
      urlBrevetePhoto,
      urlSoatPhoto,
      visibleModalDocumentBrevetePhoto,
      visibleModalDocumentSoatPhoto,
      folderName,
      target,
    } = this.state;

    const loadingData =
      categoryLicenceLoading ||
      typeVehicleLoading ||
      loadingActions ||
      documentTypeLoading;

    const prefixFlagSelectOptions = (
      <Select
        onChange={e => this.onChangeCountries(e)}
        defaultValue={countrySelected}
        decorator="flagSelect"
        disabled
      >
        {(dataCountries || []).map(obj => (
          <Option key={obj.id} value={obj.id}>
            <img
              alt="Bandera"
              height={16}
              src={obj.urlFlag}
              style={{ paddingRight: 5 }}
            ></img>
          </Option>
        ))}
      </Select>
    );
    const citiesSelectOptions = (citiesCountry || []).map(obj => (
      <Option key={obj.id} value={obj.id}>
        {obj.name}
      </Option>
    ));
    const renderTypeVehicleType = (typeVehicleOptions || []).map(obj => (
      <Option key={obj.subtype} value={obj.subtype}>
        {obj.subclass}
      </Option>
    ));
    const renderCategoryLicenceType = (categoryLicenceOptions || []).map(
      obj => (
        <Option key={obj.subtype} value={obj.subtype}>
          {obj.subclass}
        </Option>
      )
    );
    const renderDocumentType = (documentTypeOptions || []).map(obj => (
      <Option key={obj.subtype} value={obj.subtype}>
        {obj.subclass}
      </Option>
    ));

    const authEditDrawer = this.props.permissionsView
      ? this.props.permissionsView.edit
      : false;

    return (
      <Container>
        <Drawer
          title={null}
          width={408}
          onClose={this.closeDrawer}
          visible={visible}
          wrapClassName={AGENCY_PORTAL_CLASS}
          bodyStyle={{ minHeight: 400, fontFamily: "Gilroy, sans-serif" }}
        >
          {loadingData ? (
            <div
              style={{
                minHeight: 360,
                position: "relative",
              }}
            >
              <Spin
                tip="Cargando..."
                size="large"
                style={{
                  left: "50%",
                  position: "absolute",
                  textAlign: "center",
                  top: "40%",
                  transform: "translate(-50%, -50%)",
                  verticalAlign: "middle",
                }}
                spinning={loadingData}
              />
            </div>
          ) : (
            <div
              style={{
                width: "100%",
                padding: "10px",
              }}
            >
              <TitleDrawer style={{ marginBottom: "20px" }}>
                <table>
                  <tbody>
                    <tr>
                      <td colSpan="2" className="title-td-onerow">
                        Editar Afiliado
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div
                          style={{
                            width: "10.4rem",
                            margin: "auto",
                            marginRight: "15px",
                          }}
                        >
                          <ImageUpload
                            imgDefault={urlImgProfile}
                            accept="image/*,.pdf"
                            multiple
                            folderName="nintendo"
                            target="profilesUsers"
                            onUpdateFields={this.onUpdateFieldsImg}
                            onDeleteImgProfile={this.onDeleteFieldsImg}
                            maxWidth={2000}
                            maxHeight={2000}
                          />
                        </div>
                      </td>
                      <td className="td-onerow">
                        <p className="title-drawer-onerow">{`${
                          dataUser && dataUser.User
                            ? `${dataUser.User.names} ${dataUser.User.lastname}`
                            : ""
                        }`}</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </TitleDrawer>

              <Row gutter={16} type="flex" justify="center">
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={24}
                  xl={24}
                  style={{
                    marginBottom: 16,
                  }}
                >
                  <CustomCollapse
                    bordered={false}
                    expandIconPosition="right"
                    accordion
                    defaultActiveKey={["1"]}
                  >
                    <Panel header="Registro de datos personales" key="1">
                      <ContainerForm
                        style={{
                          marginBottom: "10px",
                          marginTop: "5px",
                        }}
                      >
                        <span
                          style={{
                            fontWeight: "bold",
                            fontSize: "14px",
                          }}
                        >
                          Datos personales
                        </span>
                        <Col style={{ marginTop: "5px" }}>
                          <InputComponentWithBorder
                            getFieldDecorator={getFieldDecorator}
                            title="Nombres"
                            decodator="nameDrawer"
                            required
                            placeholder="Ingrese el nombre"
                            value={`${
                              dataUser && dataUser.User
                                ? dataUser.User.names
                                : ""
                            }`}
                            onChange={e =>
                              this.changeInputValue(
                                "names",
                                e.target.value,
                                "Users",
                                "string"
                              )
                            }
                          />
                        </Col>
                        <Col style={{ marginTop: "5px" }}>
                          <InputComponentWithBorder
                            getFieldDecorator={getFieldDecorator}
                            title="Apellidos"
                            decodator="lastnameDrawer"
                            required
                            placeholder="Ingrese el apellido"
                            value={`${
                              dataUser && dataUser.User
                                ? dataUser.User.lastname
                                : ""
                            }`}
                            onChange={e =>
                              this.changeInputValue(
                                "lastname",
                                e.target.value,
                                "Users",
                                "string"
                              )
                            }
                          />
                        </Col>
                        <Col style={{ marginTop: "5px" }}>
                          <SelectWithBorderComponent
                            style={{ width: "100%" }}
                            getFieldDecorator={getFieldDecorator}
                            title="Tipo de documento"
                            decodator="documentTypeIDDrawer"
                            value={
                              dataUser &&
                              dataUser.User &&
                              dataUser.User.documentTypeID
                                ? `${dataUser.User.documentTypeID}`
                                : undefined
                            }
                            options={renderDocumentType}
                            placeholder="Seleccione tipo documento"
                            onChange={e =>
                              this.changeInputValue(
                                "documentTypeID",
                                e,
                                "Users",
                                "int"
                              )
                            }
                          />
                        </Col>
                        <Col style={{ marginTop: "5px" }}>
                          <InputComponentWithBorder
                            getFieldDecorator={getFieldDecorator}
                            title="Numero de documento"
                            decodator="documentNumberDrawer"
                            placeholder="Ingrese numero de documento"
                            value={
                              dataUser && dataUser.User
                                ? dataUser.User.documentNumber
                                : ""
                            }
                            onChange={e =>
                              this.changeInputValue(
                                "documentNumber",
                                e.target.value,
                                "Users",
                                "string"
                              )
                            }
                          />
                        </Col>
                        <Col style={{ marginTop: "5px" }}>
                          <SelectWithBorderComponent
                            style={{ width: "100%" }}
                            getFieldDecorator={getFieldDecorator}
                            title="Ciudad"
                            decodator="cityID"
                            value={citySelected}
                            options={citiesSelectOptions}
                            placeholder="Ciudad"
                            disabled
                          />
                        </Col>
                        <Col style={{ marginTop: "5px" }}>
                          <InputComponentWithBorder
                            getFieldDecorator={getFieldDecorator}
                            title="Telefono"
                            decodator="phone"
                            placeholder="Telefono"
                            addonBefore={prefixFlagSelectOptions}
                            prefix=""
                            style={{
                              paddingLeft: "40px",
                            }}
                            value={
                              dataUser && dataUser.User
                                ? dataUser.User.phone
                                : ""
                            }
                            onChange={e =>
                              this.changeInputValue(
                                "phone",
                                e.target.value,
                                "Users",
                                "string"
                              )
                            }
                          />
                        </Col>
                        <Col style={{ marginTop: "5px" }}>
                          <InputComponentWithBorder
                            getFieldDecorator={getFieldDecorator}
                            title="Correo"
                            decodator="email"
                            required
                            placeholder="Correo"
                            value={
                              dataUser && dataUser.User
                                ? dataUser.User.email
                                : ""
                            }
                            onChange={e =>
                              this.changeInputValue(
                                "email",
                                e.target.value,
                                "Users",
                                "string"
                              )
                            }
                          />
                        </Col>
                      </ContainerForm>
                    </Panel>

                    <Panel header="Registro de datos vehículares" key="2">
                      <ContainerForm
                        style={{
                          marginBottom: "10px",
                          marginTop: "5px",
                        }}
                      >
                        <span
                          style={{
                            fontWeight: "bold",
                            fontSize: "14px",
                          }}
                        >
                          Datos vehiculares
                        </span>

                        <Col style={{ marginTop: "5px" }}>
                          <SelectWithBorderComponent
                            style={{ width: "100%" }}
                            getFieldDecorator={getFieldDecorator}
                            title="Tipo de vehiculo"
                            decodator="categoryVehicleIDDrawer"
                            value={
                              dataUser &&
                              dataUser.CurrentVehicle &&
                              dataUser.CurrentVehicle.categoryVehicleID
                                ? `${dataUser.CurrentVehicle.categoryVehicleID}`
                                : undefined
                            }
                            options={renderTypeVehicleType}
                            placeholder="Seleccione tipo de vehiculo"
                            onChange={e =>
                              this.changeInputValue(
                                "categoryVehicleID",
                                e,
                                "CurrentVehicle",
                                "int"
                              )
                            }
                          />
                        </Col>
                        {!isBicycle && (
                          <React.Fragment>
                            <Col style={{ marginTop: "5px" }}>
                              <InputComponentWithBorder
                                value={
                                  dataUser &&
                                  dataUser.CurrentVehicle &&
                                  dataUser.CurrentVehicle.vehiclePlate
                                    ? `${dataUser.CurrentVehicle.vehiclePlate}`
                                    : undefined
                                }
                                getFieldDecorator={getFieldDecorator}
                                title="Placa del vehiculo"
                                decodator="vehiclePlate"
                                placeholder="Ingrese placa del vehiculo"
                                onChange={e =>
                                  this.changeInputValue(
                                    "vehiclePlate",
                                    e.target.value,
                                    "CurrentVehicle",
                                    "string"
                                  )
                                }
                              />
                            </Col>
                            <Col style={{ marginTop: "5px" }}>
                              <InputComponentWithBorder
                                value={
                                  dataUser &&
                                  dataUser.AffiliateDriveInfo &&
                                  dataUser.AffiliateDriveInfo.driverLicenceNumber
                                    ? `${dataUser.AffiliateDriveInfo.driverLicenceNumber}`
                                    : undefined
                                }
                                getFieldDecorator={getFieldDecorator}
                                title="Numero de licencia de conducir"
                                decodator="driverLicenceNumberDrawer"
                                placeholder="Ingrese el numero de licencia"
                                onChange={e =>
                                  this.changeInputValue(
                                    "driverLicenceNumber",
                                    e.target.value,
                                    "DriverInfo",
                                    "string"
                                  )
                                }
                              />
                            </Col>
                            <Col style={{ marginTop: "5px" }}>
                              <SelectWithBorderComponent
                                style={{ width: "100%" }}
                                getFieldDecorator={getFieldDecorator}
                                title="Clase y categoria de licencia"
                                decodator="driverLicenceCategoryIDDrawer"
                                value={
                                  dataUser &&
                                  dataUser.AffiliateDriveInfo &&
                                  dataUser.AffiliateDriveInfo
                                    .driverLicenceCategoryID
                                    ? `${dataUser.AffiliateDriveInfo.driverLicenceCategoryID}`
                                    : undefined
                                }
                                options={renderCategoryLicenceType}
                                placeholder="Seleccione categoria de licencia"
                                onChange={e =>
                                  this.changeInputValue(
                                    "driverLicenceCategoryID",
                                    e,
                                    "DriverInfo",
                                    "int"
                                  )
                                }
                              />
                            </Col>
                            <Col style={{ marginTop: "5px" }}>
                              <div style={{ with: "100%", textAlign: "left" }}>
                                <span
                                  style={{
                                    fontSize: "12px",
                                    lineHeight: "16px",
                                    fontWeight: "500",
                                    color: "#262626",
                                  }}
                                >
                                  Fecha de vencimiento licencia
                                </span>
                              </div>
                              <CustomDatePicker
                                size="large"
                                placeholder="Seleccionar fecha"
                                format="DD/MM/YYYY"
                                style={{ fontSize: "12px" }}
                                defaultValue={
                                  dataUser &&
                                  dataUser.AffiliateDriveInfo &&
                                  dataUser.AffiliateDriveInfo
                                    .driverLicenceExpirationDate
                                    ? moment(
                                        dataUser.AffiliateDriveInfo
                                          .driverLicenceExpirationDate,
                                        "YYYY-MM-DD"
                                      )
                                    : null
                                }
                                onChange={e =>
                                  this.changeInputValue(
                                    "driverLicenceExpirationDate",
                                    moment(e).format(),
                                    "DriverInfo",
                                    "string"
                                  )
                                }
                              />
                            </Col>
                          </React.Fragment>
                        )}
                      </ContainerForm>
                    </Panel>

                    {!isBicycle ? (
                      <Panel header="Documentos" key="3">
                        <ContainerForm
                          style={{
                            marginBottom: "10px",
                            marginTop: "15px",
                          }}
                        >
                          <span
                            style={{
                              fontWeight: "bold",
                              fontSize: "14px",
                            }}
                          >
                            Documentos
                          </span>
                          <Row style={{ padding: "8px" }}>
                            <Col style={{ marginTop: "5px" }}>
                              <label
                                style={{
                                  fontSize: "12px",
                                }}
                              >
                                Brevete
                              </label>
                            </Col>
                            <Col
                              style={{
                                marginTop: "5px",
                                marginRight: "10px",
                                marginLeft: "10px",
                              }}
                            >
                              <Button
                                type="primary"
                                style={{ width: "100%", size: "large" }}
                                ghost
                                onClick={this.showModalDocumentBrevetePhoto}
                              >
                                Brevete.png <Icon type="search" />
                              </Button>
                            </Col>
                          </Row>
                          <Row style={{ padding: "8px" }}>
                            <Col style={{ marginTop: "5px" }}>
                              <label
                                style={{
                                  fontSize: "12px",
                                }}
                              >
                                SOAT
                              </label>
                            </Col>
                            <Col
                              style={{
                                marginTop: "5px",
                                marginRight: "10px",
                                marginLeft: "10px",
                              }}
                            >
                              <Button
                                type="primary"
                                style={{ width: "100%", size: "large" }}
                                ghost
                                onClick={this.showModalDocumentSoatPhoto}
                              >
                                SOAT.png <Icon type="search" />
                              </Button>
                            </Col>
                          </Row>
                        </ContainerForm>
                      </Panel>
                    ) : (
                      ""
                    )}

                    <Panel header="Resetear Contraseña" key="4">
                      <ContainerForm
                        style={{
                          marginBottom: "10px",
                          marginTop: "0px",
                        }}
                      >
                        <Row style={{ padding: "8px" }}>
                          <Col
                            style={{
                              marginTop: "0px",
                              marginRight: "10px",
                              marginLeft: "10px",
                            }}
                          >
                            <Button
                              type="primary"
                              style={{ width: "100%", size: "large" }}
                              ghost
                              onClick={this.props.showModalSendEmailAccount}
                              disabled={!authEditDrawer}
                            >
                              Generar contraseña
                            </Button>
                          </Col>
                        </Row>
                      </ContainerForm>
                    </Panel>
                  </CustomCollapse>
                </Col>
              </Row>
              <BlockSeparator></BlockSeparator>

              <ContainerButtons>
                <CustomRow gutter={24} type="flex" justify="space-around">
                  <Button
                    type="primary"
                    style={{
                      fontFamily: "Gilroy, sans-serif",
                      fontWeight: "600",
                      fontSize: "14px",
                      lineSeight: "16px",
                      height: "40px",
                      width: "200px",
                    }}
                    loading={loadingBtnSubmit}
                    onClick={this.submitDataForm}
                    disabled={!authEditDrawer}
                  >
                    Guardar cambios
                  </Button>
                </CustomRow>
              </ContainerButtons>
              {visibleModalDocumentBrevetePhoto && (
                <UploadModalFile
                  folderName={folderName}
                  target={target}
                  updateFieldURL={this.onUpdateFieldDocumentBrevetePhoto}
                  srcFile={urlBrevetePhoto}
                  onHandleCancelModal={this.hideModalDocumentBrevetePhoto}
                  visible={visibleModalDocumentBrevetePhoto}
                  validFormats={["", "image/png", "image/jpeg", "image/jpg"]}
                />
              )}
              {visibleModalDocumentSoatPhoto && (
                <UploadModalFile
                  folderName={folderName}
                  target={target}
                  updateFieldURL={this.onUpdateFieldDocumentSoatPhoto}
                  srcFile={urlSoatPhoto}
                  onHandleCancelModal={this.hideModalDocumentSoatPhoto}
                  visible={visibleModalDocumentSoatPhoto}
                  validFormats={["", "image/png", "image/jpeg", "image/jpg"]}
                />
              )}
            </div>
          )}
        </Drawer>
      </Container>
    );
  }
}

const WrapperDrawer = withGlobal(DrawerComponent);
const DrawerComponentForm = Form.create()(WrapperDrawer);

export default compose(
  graphql(documentTypeAffiliates, {
    name: "documentType",
    options: () => {
      return {
        notifyOnNetworkStatusChange: true,
        variables: {},
      };
    },
  }),
  graphql(typeVehicleAffiliates, {
    name: "typeVehicle",
    options: () => {
      return {
        notifyOnNetworkStatusChange: true,
        variables: {},
      };
    },
  }),
  graphql(categoryLicenceAffiliates, {
    name: "categoryLicence",
    options: () => {
      return {
        notifyOnNetworkStatusChange: true,
        variables: {},
      };
    },
  }),
  withApollo
)(DrawerComponentForm);
